export const dataToExcel = (data: string, name: string): void => {
  if (!document) return

  const link = document.createElement('a')
  link.href = `data:application/octet-stream;base64,${data}`
  link.download = `${name}.xlsx`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
